module.exports = __webpack_public_path__ + "img/idea_bg.77c388e9.png";